import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseResponseDTO } from 'src/app/core/models/app.models';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { ApiService } from 'src/app/shared/services/api.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { environment } from 'src/environments/environment';
import { ChangePassword, ConfirmEmail } from 'src/app/modules/authentication/components/models/autentication-dto.models';
import { UserService } from 'src/app/shared/services/user.service';
import { lastValueFrom } from 'rxjs';
import en from 'src/assets/i18n/en';  
import { FormValidationService } from 'src/app/shared/services/form-validation.service'; 
import { AuthenticationActions } from 'src/app/modules/authentication/components/models/authentication-actions.enum'; // Adjust the import path

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['../../../authentication/components/authentication/authentication.component.scss'] 
})


export class ChangePasswordComponent  implements OnInit {
  returnUrl: string = '';
  translations = en;
  AppConstants = AppConstants;
  invalidSubmit= false;
  email: string | null = null;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  private _ChangePasswordForm!: FormGroup;
  
  public get ChangePasswordForm(): FormGroup {
    return this._ChangePasswordForm;
  }
  //#endregion
  //#region setters
  public set ChangePasswordForm(value: FormGroup) {
    this._ChangePasswordForm = value;
  }

  
  constructor(
    private _router: Router,
    private _activeRoute : ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private _dialogService: DialogService,
    private _loaderService: LoaderService,
    private _userService: UserService,
    private formValidationService: FormValidationService 
  ) { }

  ngOnInit(): void {
    this.email = this._userService.email;
    if (!this.email) {
      // Redirect back to login if email is not set
       this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
    }

    this.initialize();
    this._activeRoute.queryParams.subscribe(params => this.returnUrl = params['returnUrl']);
  }

  private initialize() {
    this.initializeForm();
  }

  private initializeForm() {
    this._ChangePasswordForm = this._formBuilder.group({
      Password: ['', [Validators.required, Validators.minLength(6)]],
      ConfirmPassword: ['', Validators.required]
    }); 
    
  }

  
  public isFormValid() {
    return this.ChangePasswordForm.valid;
  }

  private ConfirmAndPassMatchesAndStrength(password : string,ConfirmPassword : string) {
    const isValid = password.length >= 8 &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[0-9]/.test(password) &&
    /[^a-zA-Z0-9]/.test(password);
    if (!isValid) {
      this.formValidationService.setCustomError(this.ChangePasswordForm.get('ConfirmPassword'), this.translations.common.PasswordStrength);
      return false;
    }
    if (password !== ConfirmPassword) {
      this.formValidationService.setCustomError(this.ChangePasswordForm.get('ConfirmPassword'), this.translations.common.ConfirmedPassdontMatch);
      return false;
    }
    return true;
  }

  public onSubmitForm(event: Event) {


    event.preventDefault();
    this.invalidSubmit = false;

    if(this.isFormValid()) {
      if (!this.ConfirmAndPassMatchesAndStrength(this.ChangePasswordForm.get('Password')?.value,this.ChangePasswordForm.get('ConfirmPassword')?.value)) {
        return;
      }
      let data = this.ChangePasswordForm.getRawValue();
      this.handleValidateUser(data);
    } else {
      this.markFormGroupTouched(this.ChangePasswordForm);
      this.invalidSubmit =true;
    }
  }
  
  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }

    //#region API Service
    private createApiService(): ApiService {
      const apiService = new ApiService(this._http);
      apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
      return apiService;
    }
    //#endregion
  
    //#region Payloads
    private prepareValidateUserRequestPayload(data: any) {
      return data as ChangePassword;
    }
    //#endregion
    

    



    //#region Fire HTTP Requests
    private fireValidateUserRequest(apiService: ApiService, payload: ChangePassword) {
      let req$ = apiService.post(AppConstants.CONTROLLERS.USER, AppConstants.ACTIONS.ForceChangePassword, true, environment.APIs_PREFIX, payload);
      return lastValueFrom(req$);
    } 
  //#endregion

  private async handleValidateUser(data: any) {

    console.log('handleValidateUser called with data:', data); 
    this._loaderService.showLoader();
    const apiService = this.createApiService();
    const payload = this.prepareValidateUserRequestPayload(data);
    payload.Email = this._userService.email;
    this.fireValidateUserRequest(apiService, payload)
    .then((response: any) => {
      let result = response as unknown as BaseResponseDTO;
      if(result.isSuccess) {
       // this._userService.handleValidAuthentication(result);
        this._userService.email = '';
        this._userService.token = '';
        this._userService.user = null;
        localStorage.removeItem('QNBNToken');

        this._router.navigate(
          [AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.SUCCESS],
          { state: { message: 'Password changed Successfully' } }
        );

      } else {
        this.formValidationService.setCustomError(this.ChangePasswordForm.get('ConfirmPassowrd'), result.errorMessageEn);
      }
    })
    .catch((err: HttpErrorResponse) => {
      this._loaderService.hideLoader();
      this.invalidSubmit = true;
     

    })
    .finally(() => {
      this._loaderService.hideLoader();
    });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }




  

} 
